<app-header [active]="2" [circuito]="circuito"></app-header>
<div class=" screen-table">
  <table class="table">
    <thead>
    <tr>
      <th>#</th>
      <th>Contenido</th>
      <th style="text-align: right">Acciones</th>
    </tr>
    </thead>
    <tbody>
    <tr *ngFor="let noticia of noticias; let j = index" [ngClass]="{'table-active':noticia.edit}">
      <th scope="row">{{noticia.id + 1}}</th>
      <td>{{noticia.titulo}}</td>
      <td style="text-align: right" class="cell-options">
        <div class="btn-group">
          <div class="btn-group" ngbDropdown role="group" aria-label="Button group with nested dropdown">
            <a class="row-option-button" ngbDropdownToggle>
              <img src="../../../assets/img/captarmedia-estado-settings.png" class="row-option-icon">
            </a>
            <div class="dropdown-menu" ngbDropdownMenu>
              <a class="dropdown-item" (click)="editarModal(noticia)">Editar</a>
              <a *ngIf="noticia.edit" class="dropdown-item" (click)="deleteNoticia(noticia)">Restablecer</a>
            </div>
          </div>
        </div>
        <div ngbDropdown class="btn-group dropleft">
          <div class="dropdown-menu">
          </div>
        </div>
      </td>
    </tr>
    </tbody>
  </table>
</div>

<app-modal-new-noticia *ngIf="showmodal" [item]="item" (onsuccess)="editar($event)" (onclose)="showmodal=false"></app-modal-new-noticia>



// WEBPACK FOOTER //
// ./src/app/admin/noticias/noticias.component.html